import React from 'react';
import PageLayout from '../components/PageLayout';
import Hero from '../components/Hero';
import CTASection from '../components/CTASection';
import useBrand from '../branding/useBrand';
import useDocumentTitle from '../hooks/useDocumentTitle';
import './Page.css';
import './ProductPage.css';

function ProductPage() {
  const content = useBrand().pages.product;
  useDocumentTitle(content.title);

  return (
    <PageLayout
      hero={(
        <Hero
          title={content.title}
          lead={content.heroLead}
        />
      )}
    >
      <div className="product-page">
        <section className="page-section product-intro">
          <span className="product-eyebrow">{content.introEyebrow}</span>
          <h2>{content.introTitle}</h2>
          <p>
            {content.introBody}
          </p>
        </section>

        <nav className="page-section product-capability-nav" aria-label={content.navAriaLabel}>
          {content.sections.map((section) => (
            <a key={section.id} href={`#${section.id}`} className="product-capability-link">
              <span>{section.eyebrow}</span>
              <strong>{section.title}</strong>
            </a>
          ))}
        </nav>

        <div className="product-feature-stack">
          {content.sections.map((section, index) => (
            <section
              key={section.id}
              id={section.id}
              className={`page-section product-feature ${index % 2 === 1 ? 'product-feature-reverse' : ''}`}
            >
              <div className="product-feature-media">
                <img src={section.image} alt={section.alt} />
              </div>
              <div className="product-feature-copy">
                <span className="product-eyebrow">{section.eyebrow}</span>
                <h2>{section.title}</h2>
                <p className="product-feature-description">{section.description}</p>
                <ul className="product-highlight-list">
                  {section.highlights.map((highlight) => (
                    <li key={highlight}>{highlight}</li>
                  ))}
                </ul>
              </div>
            </section>
          ))}
        </div>

        <CTASection />
      </div>
    </PageLayout>
  );
}

export default ProductPage;
